import { render, staticRenderFns } from "./TradeShowSchedule.vue?vue&type=template&id=27db2724&scoped=true&"
import script from "./TradeShowSchedule.vue?vue&type=script&lang=js&"
export * from "./TradeShowSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TradeShowSchedule.vue?vue&type=style&index=0&id=27db2724&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db2724",
  null
  
)

export default component.exports